"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponTypes = exports.ProductTypes = exports.OrderTypes = exports.OrderStatuses = void 0;
var OrderStatuses;
(function (OrderStatuses) {
    OrderStatuses["UNPAID"] = "unpaid";
    OrderStatuses["PAID"] = "paid";
    OrderStatuses["REFUND"] = "refund";
    OrderStatuses["PARTIAL_REFUND"] = "partial_refund";
    OrderStatuses["PENDING"] = "pending";
    OrderStatuses["CANCELED"] = "canceled";
    OrderStatuses["ACTIVE"] = "active";
})(OrderStatuses = exports.OrderStatuses || (exports.OrderStatuses = {}));
var OrderTypes;
(function (OrderTypes) {
    OrderTypes["INITIAL"] = "initial";
    OrderTypes["ONECLICK"] = "oneclick";
    OrderTypes["RECURRING"] = "recurring";
})(OrderTypes = exports.OrderTypes || (exports.OrderTypes = {}));
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["PHYSICAL"] = "physical";
    ProductTypes["DIGITAL"] = "digital";
})(ProductTypes = exports.ProductTypes || (exports.ProductTypes = {}));
var CouponTypes;
(function (CouponTypes) {
    CouponTypes["AMOUNT"] = "amount";
    CouponTypes["PERCENT"] = "percent";
})(CouponTypes = exports.CouponTypes || (exports.CouponTypes = {}));
